import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_PETITIONS_WITH_BLOCKED_SIGNATURE_EXPORT = createFcmDetails(
	'petitions_with_blocked_signature_export',
	{
		owner: 'Site Platform',
		context: 'export_service',
		import: false,
		description:
			'Comma-separated list of petition_ids, used to prevent certain petitions from being able to have their signatures exported by the starter.',
	},
);
